import copy from '../copy/en/intake.json' with { type: 'json' };
import { NATIVE_INTAKE_FIELDS } from '@ohf/core/shared';

export const DATA_STAGES = [
  {
    id: "practice",
    label: copy.practice,
    detail: copy.identityLocation,
    fields: [
      "practiceName",
      "legalCompanyName",
      "addressStreet",
      "city",
      "state",
      "zip",
      "locationCount",
      "practiceType",
      "ownership",
    ],
  },
  {
    id: "people",
    label: copy.people,
    detail: copy.signerContact,
    fields: [
      "signerName",
      "signerTitle",
      "signerCapacity",
      "email",
      "phone",
      "mobilePhone",
      "pocFirstName",
      "pocLastName",
      "pocEmail",
    ],
  },
  {
    id: "operations",
    label: copy.operations,
    detail: copy.teamWorkflow,
    fields: [
      "practiceSoftware",
      "practiceSoftwareOther",
      "daysOpen",
      "typicalHours",
      "ownerDentistCount",
      "dentistCount",
      "hygienistCount",
      "operatoryCount",
      "fteCount",
      "activePatientCount",
      "monthlyVisits",
      "intraoralScanner",
    ],
  },
  {
    id: "business",
    label: copy.business,
    detail: copy.profilePlans,
    fields: [
      "entityType",
      "npi",
      "website",
      "yearsInPractice",
      "facility",
      "consideringSellOrAcquisition",
      "anticipatingAcquisition",
      "annualRevenueRange",
      "annualCardVolumeRange",
      "cardProcessingFeeRange",
    ],
  },
  {
    id: "services",
    label: copy.services,
    detail: copy.insuranceCare,
    fields: [
      "insuranceCarriers",
      "insuranceOther",
      "procedures",
      "proceduresOther",
    ],
  },
] as const;

export const JOURNEY_STEPS = [
  ...DATA_STAGES.map(({ label, detail }) => ({ label, detail })),
  { label: copy.review, detail: copy.verifyAgreement },
  { label: copy.sign, detail: copy.consentSignature },
  { label: copy.complete, detail: copy.downloadACopy },
] as const;

const FIELD_STAGE = new Map<string, number>(
  DATA_STAGES.flatMap((stage, index) => stage.fields.map((field) => [field, index] as const)),
);
for (const field of NATIVE_INTAKE_FIELDS) FIELD_STAGE.set(`intakeProfile.${field.key}`, field.stage);
FIELD_STAGE.set('intakeProfile', 0);

export function clampDataStage(index: number): number {
  if (!Number.isFinite(index)) return 0;
  return Math.min(DATA_STAGES.length - 1, Math.max(0, Math.trunc(index)));
}

export function stageIndexForField(field: string): number {
  return FIELD_STAGE.get(field) ?? 0;
}

export function firstErrorStage(fields: Iterable<string>): number {
  let earliest = DATA_STAGES.length - 1;
  let found = false;
  for (const field of fields) {
    const stage = FIELD_STAGE.get(field);
    if (stage === undefined) continue;
    earliest = Math.min(earliest, stage);
    found = true;
  }
  return found ? earliest : 0;
}
